module.exports = __webpack_public_path__ + "img/inventory Line.9bebfe6d.svg";